import { render, staticRenderFns } from "./zipcodes.vue?vue&type=template&id=787af735&"
import script from "./zipcodes.vue?vue&type=script&lang=js&"
export * from "./zipcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/twzipcode-vue/twzipcode-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787af735')) {
      api.createRecord('787af735', component.options)
    } else {
      api.reload('787af735', component.options)
    }
    module.hot.accept("./zipcodes.vue?vue&type=template&id=787af735&", function () {
      api.rerender('787af735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/zipcodes.vue"
export default component.exports